import React from "react";
import { Layout, Typography, Card, Button } from "antd";
import {
  CheckCircleOutlined,
  LockOutlined,
  SecurityScanOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import "../LandingPage.css";
import client1 from '../client1.png';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const ClientsPage = () => {
  return (
    <Layout style={{ backgroundColor: "white", padding: "40px 20px" }}>
      <Content style={{ maxWidth: "1200px", margin: "0 auto", display: "flex", flexDirection: "row", alignItems: "center", gap: "40px", flexWrap: "wrap" }}>
        <div style={{ flex: "1", minWidth: "300px", maxWidth: "600px" }}>
          <Title level={2}>Informasjon til klienter om Kipler AI</Title>
          <Title level={4}>Hva er Kipler AI, og hvordan hjelper det oss?</Title>
          <Paragraph style={{ fontSize: '1.2rem', fontWeight: '300' }}>
            Kipler AI er et verktøy vi bruker for å gjøre arbeidet vårt som psykologer mer effektivt og sikre at vi gir deg den beste hjelpen vi kan. Det lar oss ta lydopptak av samtalene våre, som deretter transkriberes og anonymiseres. Dette betyr at all personlig informasjon som navn og stedsnavn fjernes fra teksten, slik at vi kan jobbe med dataene uten at de kan spores tilbake til deg.
          </Paragraph>
        </div>
        <div style={{ flex: "1", minWidth: "300px", maxWidth: "400px", textAlign: "center" }}>
          <img
            src={client1}
            alt="Kipler AI illustrasjon"
            style={{ width: "100%", maxWidth: "400px", height: "auto", borderRadius: "8px" }}
          />
        </div>
      </Content>

      <Content style={{ maxWidth: "1200px", margin: "0 auto", marginTop: "40px" }}>

        {/* Hvorfor tar vi opp samtalene våre? */}
        <Title level={3} style={{ marginTop: "40px", textAlign:"center" }}>Hvorfor tar vi opp samtalene våre?</Title>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
          marginTop: "20px",
        }}>
          {[{
            icon: <CheckCircleOutlined style={{ fontSize: "32px", color: "#230518" }} />, 
            title: "Fange detaljer", 
            text: "Noen ganger kan det være vanskelig å huske alt som blir sagt i løpet av en samtale. Opptakene lar oss fokusere fullt på deg i stedet for å bruke tid på notater."
          }, {
            icon: <CheckCircleOutlined style={{ fontSize: "32px", color: "#230518" }} />, 
            title: "Analysere bedre", 
            text: "Etter samtalen bruker vi et smart analyseverktøy for å oppsummere og finne mønstre i det vi har snakket om. Dette hjelper oss med å skreddersy behandlingen til deg."
          }, {
            icon: <CheckCircleOutlined style={{ fontSize: "32px", color: "#230518" }} />, 
            title: "Forbedre dokumentasjon", 
            text: "Vi kan lage nøyaktige journalnotater raskere, slik at vi har bedre tid til å planlegge neste samtale med deg."
          }].map((item, index) => (
            <Card key={index} style={{ padding: "20px", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)", textAlign: "center" }}>
              <div style={{ backgroundColor: "#fdddc5", borderRadius: "50%", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 15px" }}>
                {item.icon}
              </div>
              <Title level={4}>{item.title}</Title>
              <Paragraph>{item.text}</Paragraph>
            </Card>
          ))}
        </div>

        {/* Er informasjonen trygg? */}
        <Title level={3} style={{ marginTop: "40px", textAlign:"center" }}>Er informasjonen trygg?</Title>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
          marginTop: "20px",
        }}>
          {[{
            icon: <SecurityScanOutlined style={{ fontSize: "32px", color: "#15524F" }} />, 
            title: "Anonymisering", 
            text: "Når samtalen transkriberes, fjernes all personlig informasjon, som navn og steder, automatisk."
          }, {
            icon: <LockOutlined style={{ fontSize: "32px", color: "#230518" }} />, 
            title: "Kryptering", 
            text: "Dataene er kryptert hele veien, slik at ingen andre kan få tilgang til dem."
          }, {
            icon: <CheckCircleOutlined style={{ fontSize: "32px", color: "#230518" }} />, 
            title: "Sletting", 
            text: "Lydopptak slettes umiddelbart etter at de er brukt til transkripsjon."
          }].map((item, index) => (
            <Card key={index} style={{ padding: "20px", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)", textAlign: "center" }}>
              <div style={{ backgroundColor: "#fdddc5", borderRadius: "50%", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 15px" }}>
                {item.icon}
              </div>
              <Title level={4}>{item.title}</Title>
              <Paragraph>{item.text}</Paragraph>
            </Card>
          ))}
        </div>

        {/* Call-to-Action */}
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <Title level={3}>Har du spørsmål?</Title>
          <Paragraph style={{ fontSize: "1.2rem", fontWeight: "300" }}>
            Hvis det er noe du lurer på, for eksempel hvordan opptakene brukes, eller hvordan vi sikrer personvernet ditt, er det bare å spørre oss eller snakk med behandleren din. Vi ønsker at du skal føle deg helt trygg og komfortabel med hvordan vi bruker Kipler AI i behandlingen.
          </Paragraph>
          <Button
            type="default"
            size='large'
            style={{ borderColor: '#230518', color: '#230518' }}
            icon={<MessageOutlined />}
            onClick={() => {
              if (window.tidioChatApi) {
                window.tidioChatApi.open();
              } else {
                console.warn("Tidio-chat er ikke lastet inn.");
              }
            }}
          >
            Chat med oss
          </Button>
        </div>
      </Content>
    </Layout>
  );
};

export default ClientsPage;